import { defaultKitThemes, STUDIO_THEMES } from 'fym-shared/src/music24/studioThemes';
import { buildStudioItems } from '../../music24/promote/studio/studioRules';
import type { CreateKitAssetItem } from '../../../redux/api/fymAPI.types';

/** The create route takes 1 to 20 items. */
const MAX_ITEMS = 20;

export type FirstKitSong = Parameters<typeof buildStudioItems>[2];

/**
 * The free images of the first release (spec 4.4): the default kit, image themes only. A video
 * needs the audio, so the videos come later from the unlock cards. At most 20 items.
 */
export function firstKitItems(input: {
  releaseDate: string | null;
  today: string;
  song: FirstKitSong;
}): CreateKitAssetItem[] {
  return defaultKitThemes({ releaseDate: input.releaseDate, today: input.today })
    .filter(({ themeId }) => STUDIO_THEMES[themeId].format === 'image')
    .flatMap(({ themeId, moment }) => buildStudioItems(themeId, { moment }, input.song) ?? [])
    .slice(0, MAX_ITEMS);
}

/** The song facts of a new catalog row: no master, no lyrics, no AI reels. */
export function newSongContext(daysToRelease: number | null): FirstKitSong {
  return { masterReady: false, daysToRelease, canUseAiReels: false, hasLyrics: false, hookStartSec: null };
}
